export function initPort(app) {

  app.ports.select && app.ports.select.subscribe(select);

  function select(request) {
    setTimeout(function() {
       const el = document.getElementById(request);
       if (el.setSelectionRange !== undefined){
          el.setSelectionRange(0, el.value.length)
       }
    });
  }
}
